import { useEffect, useState } from "react";

const useTimer = (targetDate, onlyHours) => {
  const countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(countDownDate);

  useEffect(() => {
    if (targetDate) {
      const interval = setInterval(() => {
        if (countDown < 0) {
          clearInterval(interval);
        }
        setCountDown(countDownDate - new Date().getTime());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [targetDate]);

  return onlyHours ? getTimeInHours(countDown) : getReturnValues(countDown);
};

const getTimeInHours = (countDown) => {
  if (countDown > 0) {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(countDown / (1000 * 60 * 60));
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    return [days, hours, minutes, seconds];
  } else {
    return [0, 0, 0, 0];
  }
};

const getReturnValues = (countDown) => {
  // calculate time left
  if (countDown > 0) {
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    return [days, hours, minutes, seconds];
  } else {
    return [0, 0, 0, 0];
  }
};

export default useTimer;
